<div *ngIf="this.currentUserId != 0">
  <div class="row">
    <div class="col-md-12">
      <h4>Phone number validation</h4>
      <label>We sent the code to your phone <b>{{ this.currentUserPhone }}</b></label>
    </div>
  </div>
  <div class="row" style="margin-top: 1rem;">
    <div class="col-md-12">
      <span>Please enter 6 digits validation SMS code</span>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12" style="padding-top: 0.5rem">
      <input 
      class="customized-input"
      style="width:auto !important; margin-right: 1rem;"
      [value]="validationCode"
      [(ngModel)]="validationCode" maxlength="6" size="6" />
    
    
      <button
        mat-raised-button
        color="primary"
        [disabled]="!allowPerformValidation"
        (click)="performPhoneValidation($event)"
        class=""
      >
        {{ !this.validationInProgress ? "Validate" : "Performing validation" }}
      </button>
   </div>
  </div>
  <div class="row" style="margin-top: 1rem;">
    <div class="col-md-12" style="margin-bottom: 0.5rem;"><label class="mb-0">Didn't receive the code ?</label></div>
    <div class="col-md-12">
      <button
        mat-raised-button
        color="primary"
        [disabled]="sendingInProgress"
        (click)="firstSendConfirmed=false; sendPhoneValidationSms($event); "
      >
        Resend the code
      </button>
    </div>
  </div>
</div>
